<admin-table-standard [items]="getEntry().data">
  <ng-template #header>
    <th scope="col" class="col-md-4">{{'pages.lookup.single.result.info.property' | translate}}</th>
    <th scope="col" class="col-md-8">{{'pages.lookup.single.result.info.value' | translate}}</th>
  </ng-template>
  <ng-template #first let-item>
    <td>{{ item.config?.name }}</td>
    <td class="alert-entry-data text-break"> {{ item.value }}</td>
  </ng-template>
</admin-table-standard>
